import { Component, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-standard-development-application1',
  templateUrl: './standard-development-application1.component.html',
  styleUrls: ['./standard-development-application1.component.scss']
})
export class StandardDevelopmentApplication1Component implements OnInit {

  constructor(
    public activeModal: NgbActiveModal,
  ) { }

  ngOnInit(): void {
  }

}
